<template>
  <div id="templatePane">
    <div class="hero-section shade-40">
      <div class="hero-section-text row column">
        <h1>Need some help getting started?</h1>
      </div>
    </div>
    <section id="mainContent" class="row column">
        <h2>Help articles</h2>
        <p>We've got a few articles here to help you get started.  If you're on the intranet and have access to FixIT, keep an eye out for a content centre full of information that will be launched very shortly.</p>
        <ul class="list-of-links">
          <li><a href="/faqs">Frequently asked questions</a></li>
          <li><a href="/help-25849">Setup Workplace on an Android device</a></li>
          <li><a href="/help-25850">Setup Workplace Chat on an Android device</a></li>
          <li><a href="/help-25852">Setup Workplace on an iOS device</a></li>
          <li><a href="/help-25853">Setup Workplace Chat on an iOS device</a></li>
          <li><a href="/help-25858">Setup Workplace on a BT Webtop Phone 8 or 10 or a personal PC</a></li>
          <li><a href="/help-25921">Setup Workplace on a BT Webtop PC</a></li>
          <li><a href="/help-security">What to do if your account has been compromised</a></li>
          <li><a href="/help-25862">How to fix Multi Factor Authentication issues</a></li>
          <li><a href="/help-privacy">Data sharing and your rights</a></li>
          
        </ul>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Help'
}
</script>